export default {
  'pages.layouts.userLayout.title': 'こんにちは！',
  'pages.getCaptchaSecondText': '秒',
  'pages.workbench.link': 'ようこそ',
  'pages.workbench.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',
  'pages.customerIntelligence.customerList.columns.name': '顧客名',
  'pages.customerIntelligence.customerList.columns.owner': '担当者',
  'pages.customerIntelligence.customerList.columns.mobile': '携帯番号',
  'pages.customerIntelligence.customerList.columns.email': 'メール',
  'pages.customerIntelligence.customerList.columns.followUpStatus':
    'フォロー状況',
  'pages.customerIntelligence.customerList.columns.lockStatus': 'ロック状態',
  'pages.customerIntelligence.customerList.columns.dealStatus': '成約状態',
  'pages.customerIntelligence.customerList.columns.contactLastTime':
    '最終連絡日時',
  'pages.customerIntelligence.customerList.columns.contactNextTime':
    '次回連絡日時',
  'pages.customerIntelligence.customerList.search.keyword': 'キーワード',
  'pages.customerIntelligence.customerList.placeholder.empty': '-',
  'pages.customerIntelligence.customerList.empty': '顧客データはありません',
  'pages.customerIntelligence.customerList.boolean.yes': 'はい',
  'pages.customerIntelligence.customerList.boolean.no': 'いいえ',
  'pages.customerIntelligence.customerList.create.button': '顧客を作成',
  'pages.customerIntelligence.customerList.create.modalTitle': '顧客を作成',
  'pages.customerIntelligence.customerList.create.success':
    '顧客を作成しました',
  'pages.customerIntelligence.customerList.create.form.name': '顧客名',
  'pages.customerIntelligence.customerList.create.form.name.required':
    '顧客名を入力してください',
  'pages.customerIntelligence.customerList.create.form.name.placeholder':
    '顧客名を入力してください',
  'pages.customerIntelligence.customerList.create.form.mobile': '携帯番号',
  'pages.customerIntelligence.customerList.create.form.telephone': '電話番号',
  'pages.customerIntelligence.customerList.create.form.email': 'メール',
  'pages.customerIntelligence.customerList.create.form.qq': 'QQ',
  'pages.customerIntelligence.customerList.create.form.wechat': 'WeChat',
  'pages.customerIntelligence.customerList.create.form.remark': '備考',
  'pages.customerIntelligence.customerList.alert.missingTenant':
    'テナントコンテキストがないため、結果が不完全な可能性があります。',
  'pages.customerIntelligence.customerList.alert.missingMember':
    '現在のセッションに memberUuid がないため、「自分の顧客」を照会できません。',
  'pages.zyConsultantOperations.diagnosisSessions.columns.customerName':
    '顧客名',
  'pages.zyConsultantOperations.diagnosisSessions.columns.title': 'タイトル',
  'pages.zyConsultantOperations.diagnosisSessions.columns.diagnosisDate':
    '診断日',
  'pages.zyConsultantOperations.diagnosisSessions.columns.industry': '業界',
  'pages.zyConsultantOperations.diagnosisSessions.columns.intervieweeRole':
    '面談対象',
  'pages.zyConsultantOperations.diagnosisSessions.columns.status': 'ステータス',
  'pages.zyConsultantOperations.diagnosisSessions.columns.overallRiskLevel':
    '総合リスク',
  'pages.zyConsultantOperations.diagnosisSessions.columns.actions': '操作',
  'pages.zyConsultantOperations.diagnosisSessions.actions.detail': '詳細',
  'pages.zyConsultantOperations.diagnosisSessions.actions.run': '実行',
  'pages.zyConsultantOperations.diagnosisSessions.actions.result': '結果',
  'pages.zyConsultantOperations.diagnosisSessions.search.placeholder':
    'タイトル/顧客/業界を検索',
  'pages.zyConsultantOperations.diagnosisSessions.search.statusPlaceholder':
    'ステータス',
  'pages.zyConsultantOperations.diagnosisSessions.create.button':
    '診断セッションを作成',
  'pages.zyConsultantOperations.diagnosisSessions.create.modalTitle':
    '診断セッションを作成',
  'pages.zyConsultantOperations.diagnosisSessions.create.success':
    '診断セッションを作成しました',
  'pages.zyConsultantOperations.diagnosisSessions.form.pack': '質問パック',
  'pages.zyConsultantOperations.diagnosisSessions.form.customer': '顧客',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerPlaceholder':
    '自分の顧客を検索して選択',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerLoadFailed':
    '顧客一覧の読み込みに失敗しました',
  'pages.zyConsultantOperations.diagnosisSessions.form.missingMember':
    '現在のセッションに memberUuid がないため、「自分の顧客」を読み込めません。',
  'pages.zyConsultantOperations.diagnosisSessions.form.titleSuggestionFailed':
    'タイトル候補の生成に失敗しました',
  'pages.zyConsultantOperations.diagnosisSessions.form.customerName': '顧客名',
  'pages.zyConsultantOperations.diagnosisSessions.form.title': 'タイトル',
  'pages.zyConsultantOperations.diagnosisSessions.form.titlePlaceholder':
    '顧客から自動生成され、必要に応じて編集できます',
  'pages.zyConsultantOperations.diagnosisSessions.form.diagnosisDate': '診断日',
  'pages.zyConsultantOperations.diagnosisSessions.form.industry': '業界',
  'pages.zyConsultantOperations.diagnosisSessions.form.intervieweeRole':
    '面談対象',
  'pages.zyConsultantOperations.diagnosisSessions.form.sourceChannel':
    '流入チャネル',
  'pages.zyConsultantOperations.diagnosisSessions.form.required':
    'この項目は必須です',
  'pages.zyConsultantOperations.diagnosisSessions.status.draft': '下書き',
  'pages.zyConsultantOperations.diagnosisSessions.status.inProgress': '進行中',
  'pages.zyConsultantOperations.diagnosisSessions.status.completed': '完了',
  'pages.zyConsultantOperations.diagnosisRun.loading': '読み込み中...',
  'pages.zyConsultantOperations.diagnosisRun.titlePrefix': '診断実行',
  'pages.zyConsultantOperations.diagnosisRun.boolean.yes': 'はい',
  'pages.zyConsultantOperations.diagnosisRun.boolean.no': 'いいえ',
  'pages.zyConsultantOperations.diagnosisRun.field.evidenceSummary':
    '証拠サマリー',
  'pages.zyConsultantOperations.diagnosisRun.field.note': 'コンサルタントメモ',
  'pages.zyConsultantOperations.diagnosisRun.action.save': '回答を保存',
  'pages.zyConsultantOperations.diagnosisRun.action.finish': '診断を完了',
  'pages.zyConsultantOperations.diagnosisRun.message.answersSaved':
    '回答を保存しました',
  'pages.zyConsultantOperations.diagnosisRun.message.finished':
    '診断が完了しました',
  'pages.zyConsultantOperations.diagnosisResult.loading': '読み込み中...',
  'pages.zyConsultantOperations.diagnosisResult.cardTitle': '診断結果',
  'pages.zyConsultantOperations.diagnosisResult.card.overallRisk': '総合リスク',
  'pages.zyConsultantOperations.diagnosisResult.card.highRisk': '高リスク',
  'pages.zyConsultantOperations.diagnosisResult.card.mediumRisk': '中リスク',
  'pages.zyConsultantOperations.diagnosisResult.card.lowRisk': '低リスク',
  'pages.zyConsultantOperations.diagnosisResult.section.dimensionScores':
    'ディメンション別スコア',
  'pages.zyConsultantOperations.diagnosisResult.section.highlightedQuestions':
    '重点課題',
  'pages.zyConsultantOperations.diagnosisResult.section.suggestionDirections':
    '提案方向',
  'pages.zyConsultantOperations.diagnosisResult.column.frameworkType':
    'フレームワーク',
  'pages.zyConsultantOperations.diagnosisResult.column.level1': 'レベル1',
  'pages.zyConsultantOperations.diagnosisResult.column.level2': 'レベル2',
  'pages.zyConsultantOperations.diagnosisResult.column.averageScore': '平均点',
  'pages.zyConsultantOperations.diagnosisResult.column.answeredCount': '回答数',
  'pages.zyConsultantOperations.diagnosisResult.column.questionTitle': '質問',
  'pages.zyConsultantOperations.diagnosisResult.column.riskLevel': 'リスク',
  'pages.zyConsultantOperations.diagnosisResult.column.causeType': '要因',
  'pages.zyConsultantOperations.diagnosisResult.column.solutionDirection':
    '施策方向',
  'pages.zyConsultantOperations.diagnosisResult.column.answer': '回答',
  'pages.zyConsultantOperations.diagnosisDetail.loading': '読み込み中...',
  'pages.zyConsultantOperations.diagnosisDetail.invalidUuid':
    '診断セッション uuid がありません',
  'pages.zyConsultantOperations.diagnosisDetail.titleFallback':
    '診断セッション',
  'pages.zyConsultantOperations.diagnosisDetail.tab.basic': '基本情報',
  'pages.zyConsultantOperations.diagnosisDetail.tab.questions': '質問パック',
  'pages.zyConsultantOperations.diagnosisDetail.tab.analysis': '統計分析',
  'pages.zyConsultantOperations.diagnosisDetail.field.createdAt': '作成日時',
  'pages.zyConsultantOperations.diagnosisDetail.field.startedAt': '開始日時',
  'pages.zyConsultantOperations.diagnosisDetail.field.completedAt': '完了日時',
  'pages.zyConsultantOperations.diagnosisDetail.message.started':
    '診断セッションを開始しました',
  'pages.zyConsultantOperations.diagnosisDetail.questions.notStarted':
    'このセッションはまだ開始されていません',
  'pages.zyConsultantOperations.diagnosisDetail.questions.start':
    '開始して回答',
  'pages.zyConsultantOperations.diagnosisDetail.questions.empty':
    'この診断セッションには質問がありません',
  'pages.zyConsultantOperations.diagnosisDetail.analysis.empty':
    '統計分析データはまだありません。先に回答を保存してください。',
  'pages.zyConsultantOperations.settings.tab.codeRules': 'コードルール',
  'pages.zyConsultantOperations.settings.tab.dict': '辞書管理',
  'pages.zyConsultantOperations.settings.tab.taxonomy': 'タグ管理',
  'pages.zyConsultantOperations.settings.dict.types': '辞書タイプ',
  'pages.zyConsultantOperations.settings.dict.items': '辞書項目',
  'pages.zyConsultantOperations.settings.dict.questionCategory': '質問カテゴリ',
  'pages.zyConsultantOperations.settings.taxonomy.list': '分類法一覧',
  'pages.zyConsultantOperations.settings.taxonomy.tree': 'タグツリー',
  'pages.zyConsultantOperations.settings.taxonomy.aiWorkbench': 'AI タグ追加',
  'pages.zyConsultantOperations.settings.taxonomy.generateOptions':
    '生成オプション',
  'pages.zyConsultantOperations.settings.taxonomy.preview': 'プレビュー結果',
  'pages.zyConsultantOperations.settings.taxonomy.previewHint':
    '追加したいタグを選択してツリーへ反映します',
  'pages.zyConsultantOperations.settings.taxonomy.target': '現在の配置先',
  'pages.zyConsultantOperations.settings.taxonomy.targetChild':
    '子タグとして追加',
  'pages.zyConsultantOperations.settings.taxonomy.targetRoot':
    'ルートタグとして追加',
  'pages.zyConsultantOperations.settings.taxonomy.rootTarget':
    '現在の分類法ルート',
  'pages.zyConsultantOperations.settings.taxonomy.targetHint':
    '左側のタグツリーでタグを選ぶと、候補をその配下にまとめて追加できます。',
  'pages.zyConsultantOperations.settings.taxonomy.mode': '分解モード',
  'pages.zyConsultantOperations.settings.taxonomy.modeSmart':
    'できるだけ多くスマート分解',
  'pages.zyConsultantOperations.settings.taxonomy.modeCount': '指定数で分解',
  'pages.zyConsultantOperations.settings.taxonomy.modeManual':
    '手入力（1行1件）',
  'pages.zyConsultantOperations.settings.taxonomy.subject': '分解テーマ',
  'pages.zyConsultantOperations.settings.taxonomy.subjectPlaceholder':
    '例：組織連携、データ統治、経営分析',
  'pages.zyConsultantOperations.settings.taxonomy.subjectPlaceholderSelected':
    '選択したタグを前提にさらに絞り込むテーマを追加できます',
  'pages.zyConsultantOperations.settings.taxonomy.targetCount': '目標件数',
  'pages.zyConsultantOperations.settings.taxonomy.manualInput': '手入力',
  'pages.zyConsultantOperations.settings.taxonomy.manualInputPlaceholder':
    'タグ案を1行ずつ入力してください。例：\nプロセス連携\n指標整合\n振り返り運用',
  'pages.zyConsultantOperations.settings.taxonomy.prompt': '分解ヒント',
  'pages.zyConsultantOperations.settings.taxonomy.promptPlaceholder':
    '例：コンサル診断向けの言い回し、既存タグとの重複回避、組織とプロセスを優先',
  'pages.zyConsultantOperations.settings.taxonomy.aiMeta':
    '今回の分解に使用したモデル',
  'pages.zyConsultantOperations.settings.taxonomy.reason': '分解理由',
  'pages.zyConsultantOperations.settings.taxonomy.emptyCandidates':
    'モードを選んで候補を生成すると、ここで一括作成できます。',
  'pages.zyConsultantOperations.settings.column.code': 'コード',
  'pages.zyConsultantOperations.settings.column.name': '名称',
  'pages.zyConsultantOperations.settings.column.description': '説明',
  'pages.zyConsultantOperations.settings.column.value': '値',
  'pages.zyConsultantOperations.settings.column.sortOrder': '並び順',
  'pages.zyConsultantOperations.settings.column.enabled': '有効',
  'pages.zyConsultantOperations.settings.column.actions': '操作',
  'pages.zyConsultantOperations.settings.action.edit': '編集',
  'pages.zyConsultantOperations.settings.action.delete': '削除',
  'pages.zyConsultantOperations.settings.action.refresh': '更新',
  'pages.zyConsultantOperations.settings.action.moveTop': '先頭へ移動',
  'pages.zyConsultantOperations.settings.action.moveUp': '上へ',
  'pages.zyConsultantOperations.settings.action.moveDown': '下へ',
  'pages.zyConsultantOperations.settings.action.moveBottom': '末尾へ移動',
  'pages.zyConsultantOperations.settings.action.addCategory': 'カテゴリ追加',
  'pages.zyConsultantOperations.settings.action.addChildCategory':
    '子カテゴリ追加',
  'pages.zyConsultantOperations.settings.action.addDictItem': '項目追加',
  'pages.zyConsultantOperations.settings.action.addDictType': 'タイプ追加',
  'pages.zyConsultantOperations.settings.action.addTaxonomy': '分類法追加',
  'pages.zyConsultantOperations.settings.action.initEnterprisePortraitTaxonomies':
    '企業プロファイルを初期化',
  'pages.zyConsultantOperations.settings.action.addSiblingTag':
    '同階層タグを追加',
  'pages.zyConsultantOperations.settings.action.addRootTag': 'ルートタグ追加',
  'pages.zyConsultantOperations.settings.action.addChildTag': '子タグ追加',
  'pages.zyConsultantOperations.settings.action.openAiModal': 'AI タグ追加',
  'pages.zyConsultantOperations.settings.action.clearTarget': 'ルートに戻す',
  'pages.zyConsultantOperations.settings.action.clearCandidates':
    '候補をクリア',
  'pages.zyConsultantOperations.settings.action.createSelectedCandidates':
    '選択候補を作成',
  'pages.zyConsultantOperations.settings.action.generateCandidates':
    '候補を生成',
  'pages.zyConsultantOperations.settings.action.resetPrompt': '入力をクリア',
  'pages.zyConsultantOperations.settings.action.cancel': 'キャンセル',
  'pages.zyConsultantOperations.settings.modal.editDictItem': '辞書項目を編集',
  'pages.zyConsultantOperations.settings.modal.addDictType': '辞書タイプを追加',
  'pages.zyConsultantOperations.settings.modal.addDictItem': '辞書項目を追加',
  'pages.zyConsultantOperations.settings.message.dictItemUpdated':
    '辞書項目を更新しました',
  'pages.zyConsultantOperations.settings.message.dictItemCreated':
    '辞書項目を作成しました',
  'pages.zyConsultantOperations.settings.message.dictItemDeleted':
    '辞書項目を削除しました',
  'pages.zyConsultantOperations.settings.message.categoryUpdated':
    'カテゴリを更新しました',
  'pages.zyConsultantOperations.settings.message.categoryCreated':
    'カテゴリを作成しました',
  'pages.zyConsultantOperations.settings.message.taxonomyUpdated':
    '分類法を更新しました',
  'pages.zyConsultantOperations.settings.message.taxonomyCreated':
    '分類法を作成しました',
  'pages.zyConsultantOperations.settings.message.taxonomyDeleted':
    '分類法を削除しました',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesInitialized':
    '企業プロファイル分類法を初期化しました',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesCreated':
    '作成した分類法',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTagsCreated':
    '作成したタグ',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTaxonomiesSkipped':
    'スキップした分類法',
  'pages.zyConsultantOperations.settings.message.enterprisePortraitTagsSkipped':
    'スキップしたタグ',
  'pages.zyConsultantOperations.settings.message.tagUpdated':
    'タグを更新しました',
  'pages.zyConsultantOperations.settings.message.tagCreated':
    'タグを作成しました',
  'pages.zyConsultantOperations.settings.message.tagDeleted':
    'タグを削除しました',
  'pages.zyConsultantOperations.settings.message.selectTaxonomyFirst':
    '先に分類法を選択してください',
  'pages.zyConsultantOperations.settings.message.aiCandidatesReady':
    '候補タグを生成しました',
  'pages.zyConsultantOperations.settings.message.selectCandidateFirst':
    '少なくとも1件の候補タグを選択してください',
  'pages.zyConsultantOperations.settings.message.aiCreatePartial':
    '候補タグの作成が完了しました',
  'pages.zyConsultantOperations.settings.message.aiCreateSuccess':
    '候補タグを一括作成しました',
};
